import React from 'react';
import { FormattedMessage } from 'react-intl';

const AppHeaderLeftContainer = () => (
  <div className="header-left-container">
    <div className="app-title">
      <FormattedMessage id="app.title" tagName="h1" />
    </div>
  </div>
);

export default AppHeaderLeftContainer;
